<template>
  <section class="finale" aria-labelledby="finale-title">
    <div class="glow" aria-hidden="true"></div>
    <div class="inner">
      <figure class="photo">
        <img :src="profile.photo" :alt="profile.name + ' smiling on a clifftop'" />
      </figure>
      <div class="copy">
        <p class="pixel-font kicker">Continue? · Player 2</p>
        <h2 id="finale-title" class="display title">Let's <em>connect.</em></h2>
        <p class="lede">
          Always happy to talk startups and AI in higher ed, swap book and comic recommendations, or talk boxing.
        </p>
        <div class="actions">
          <a class="pixel-font btn btn-primary" :href="profile.linkedin" target="_blank" rel="noopener">
            Say hi on LinkedIn ↗
          </a>
          <button type="button" class="pixel-font btn" @click="replay">↺ Replay level</button>
        </div>
      </div>
    </div>
    <footer class="footer">
      <span>© {{ year }} {{ profile.name }}</span>
      <span>Made with far too many pixels</span>
    </footer>
  </section>
</template>

<script>
import { profile } from '../content'

export default {
  name: 'FinaleSection',
  data() {
    return { profile, year: new Date().getFullYear() }
  },
  methods: {
    replay() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>

<style scoped>
.finale {
  position: relative;
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  background: var(--bg-deep);
  color: var(--paper);
  overflow: hidden;
}
.glow {
  position: absolute;
  left: 50%;
  top: 40%;
  width: 70vw;
  height: 50vw;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(236, 220, 170, 0.18), rgba(47, 93, 104, 0.12) 45%, transparent 70%);
  filter: blur(40px);
  pointer-events: none;
}
.inner {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  gap: clamp(24px, 6vw, 96px);
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 96px clamp(16px, 6vw, 96px) 48px;
}
.photo {
  position: relative;
  flex: 0 0 auto;
  width: clamp(220px, 30vw, 400px);
  margin: 0;
  overflow: hidden;
  border-radius: 14px;
  box-shadow: 0 40px 80px -30px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(246, 241, 231, 0.08);
}
.photo img {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  object-position: 50% 30%;
}
/* Soft vignette so the photo sinks into the dark page */
.photo::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(120% 90% at 50% 35%, transparent 55%, rgba(10, 10, 10, 0.45));
  pointer-events: none;
}
.kicker {
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--paper-soft);
}
.title {
  margin-top: 20px;
  font-size: clamp(52px, 7vw, 112px);
  line-height: 0.95;
  letter-spacing: -0.02em;
}
.title em {
  font-style: italic;
  color: #ecdcaa;
}
.lede {
  margin-top: 24px;
  max-width: 40ch;
  font-size: clamp(16px, 1.4vw, 19px);
  line-height: 1.6;
  color: var(--paper-soft);
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 36px;
}
.btn {
  display: inline-flex;
  align-items: center;
  padding: 16px 20px;
  font-size: 13px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--paper);
  background: transparent;
  border: 2px solid var(--paper);
  box-shadow: 4px 4px 0 rgba(246, 241, 231, 0.25);
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}
.btn:hover {
  transform: translate(-2px, -2px);
  box-shadow: 6px 6px 0 rgba(246, 241, 231, 0.3);
}
.btn:active {
  transform: translate(4px, 4px);
  box-shadow: 0 0 0 transparent;
}
.btn-primary {
  color: #1b1206;
  background: #ecdcaa;
  border-color: #ecdcaa;
  box-shadow: 4px 4px 0 #8a6a2c;
}
.btn-primary:hover {
  box-shadow: 6px 6px 0 #8a6a2c;
}
.footer {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px 24px;
  padding: 24px clamp(16px, 6vw, 96px);
  border-top: 1px solid rgba(246, 241, 231, 0.12);
  font-size: 13px;
  color: var(--paper-soft);
}

@media (max-width: 699px) {
  .inner {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 72px;
  }
  .photo {
    width: min(100%, 300px);
  }
}

</style>
